// Import des types nécessaires
import { Block, isPrestation } from './Block';

// Types communs et utilitaires
export interface Position {
  x: number;
  y: number;
}

export interface SelectionArea {
  start: Position;
  end: Position;
}

export interface DropTarget {
  index: number;
  parentId?: string;
  level?: number;
  position?: 'above' | 'below' | 'on';
  top: number; // pixel offset from editor top for the drop indicator
}

// Configuration par défaut
export const DEFAULT_CONFIG = {
  allowNesting: true,
  maxNestingLevel: 999,
  defaultSectionTitle: 'Nouvelle section',
  defaultPrestationContent: {
    titre: 'Nouvelle prestation',
    intitule: 'Nouvelle prestation',
    categorie: '',
    unite: 'unité',
    prixUnitaire: '0',
    quantite: '1',
    prixTotal: '0',
    chantier: 'À définir',
    fournisseur: 'À définir'
  }
} as const;

// Utilitaires de calcul
export const calculateTotal = (blocks: Block[]): number => {
  return blocks.reduce((total, block) => {
    if (isPrestation(block)) {
      const prixUnitaire = parseFloat(block.content.prixUnitaire?.replace(/[^\d.,]/g, '').replace(',', '.') || '0');
      const quantite = parseFloat(block.content.quantite || '1');
      return total + (prixUnitaire * quantite);
    }
    return total;
  }, 0);
};
